import { ComponentPropsWithoutRef } from 'react';

export const BinIcon = ({ ...props }: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg {...props} viewBox="0 0 16 17" fill="none">
      <path
        d="M.5 3.936c0-.33.272-.595.608-.595h3.99c.005-.702.082-1.662.777-2.327A3.067 3.067 0 0 1 8 .166a3.067 3.067 0 0 1 2.125.848c.695.665.772 1.625.777 2.327h3.99c.335 0 .608.267.608.595a.6.6 0 0 1-.608.595H1.108A.6.6 0 0 1 .5 3.936Zm7.173 12.897h.655c2.256 0 3.384 0 4.117-.72.733-.719.81-1.9.96-4.259l.216-3.4c.082-1.28.121-1.921-.246-2.326-.368-.406-.99-.406-2.232-.406H4.857c-1.242 0-1.864 0-2.232.406-.368.405-.327 1.046-.246 2.326l.217 3.4c.15 2.36.225 3.54.958 4.26.733.719 1.862.719 4.117.719Z"
        fill="#000000"
      />
    </svg>
  );
};
